import Box from "ds/components/Box";
import Link from "ds/components/Link";
import Typography from "ds/components/Typography";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageAuditTrail } from "hooks/useAnalytics/pages/auditTrail";
import { AuditActor } from "types/generated";

import { AuditTrailEntrySuggestions } from "../../constants";

type AuditTrailListItemCreatedByProps = {
  value: AuditActor;
  ownerLogin?: string | null;
  applyFilter: (filterName: AuditTrailEntrySuggestions) => (value: string) => void;
};

const AuditTrailListItemCreatedBy = ({
  value,
  ownerLogin,
  applyFilter,
}: AuditTrailListItemCreatedByProps) => {
  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPageAuditTrail.Logs,
  });

  const onLinkClicked = () => {
    trackSegmentAnalyticsEvent("Link clicked", {
      column: "Created by",
    });
  };

  return (
    <>
      {value.run === null && (
        <Box align="start" justify="center" gap="small" direction="column">
          <Link
            onPress={() => {
              applyFilter(AuditTrailEntrySuggestions.Username)(value.username);
              onLinkClicked();
            }}
          >
            {value.username}
          </Link>
          {ownerLogin && (
            <Typography tag="span" variant="p-body3" color="secondary">
              ({ownerLogin})
            </Typography>
          )}
        </Box>
      )}

      {value.run && (
        <Link href={`/stack/${value.run.stackId}/run/${value.run.id}`} onPress={onLinkClicked}>
          Run: {value.run.id}
        </Link>
      )}
    </>
  );
};

export default AuditTrailListItemCreatedBy;
